import styled, { css, keyframes } from "styled-components/macro";

const slidein = keyframes`
  from {
    opacity: 0;
    transform: translate3d(0,-1rem,0);
  }

  to {
    opacity: 1;
    transform: translate3d(0,0rem,0);
  }
`;
const scaleout = keyframes`
  from {
    opacity: 0;
    transform: scale(0.8);
  }

  to {
    opacity: 1;
    transform: scale(1)
  }
`;

const Wrapper = styled.div`
  text-align: center;

  padding: 1rem;
  margin: 1rem;
  margin-left: 0;

  width: 70%;
  clear: both;
  overflow: hidden;
  @supports (display: grid) {
    width: 95%;
  }

  h2 {
    color: #888;
  }

  @media (max-width: 57rem) {
    display: grid;
    justify-content: center;
    align-items: center;
  }
  border: 1px rgba(221, 221, 221, 0.2) solid;
  @media (min-width: 57rem) {
    border: rgba(0, 95, 178, 0.2) 1px solid;
    animation: ${scaleout} 320ms ease-in-out;
    ${props =>
      props.grey &&
      css`
        border: rgba(221, 221, 221, 0.8) 1px solid;
        animation: ${slidein} 320ms ease-in-out;
      `};
  }
  @media print {
    display: none;
  }
`;

export default Wrapper;
